<div class="footer">
    <div class="grid-overlay">
        <div class="policy">
            <p>Politica de privacidad</p>
        </div>
        <div class="policy">
            <p>CIA CIAN S.A</p>
        </div>
        <div class="by-billcentrix">
            <p>Powered by Billcentrix</p>
        </div>
    </div>
</div>